var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _g2, _path16, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 59,
    viewBox: "0 0 136 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.4121 35.603V20.3328H58.3434V25.6111C59.2749 24.799 60.4176 24.393 61.759 24.393C64.4976 24.393 65.87 25.7824 65.87 28.5674V35.603H63.9387V28.5357C63.9387 26.8672 63.1252 26.0361 61.5043 26.0361C60.3928 26.0361 59.3433 26.5119 58.3496 27.4572V35.603H56.4121Z",
    fill: "#231F20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.416 24.393H69.515L72.62 33.1478L75.8306 24.393H77.8799L73.3218 35.9392C72.5145 37.9757 71.3035 39.2445 69.6827 39.752L68.9375 38.35C70.1609 37.8044 71.0551 36.9099 71.614 35.6664L67.416 24.393Z",
    fill: "#231F20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4081 20.3328H81.3394V24.9259C82.1653 24.5706 83.0596 24.393 84.0035 24.393C87.4749 24.393 89.2075 26.1884 89.2075 29.7728C89.2075 33.6617 87.388 35.603 83.7427 35.603C82.1653 35.603 80.7184 35.4508 79.4019 35.1462V20.3328H79.4081ZM81.3394 33.649C81.9728 33.8584 82.7429 33.9599 83.6495 33.9599C86.0901 33.9599 87.3072 32.5388 87.3072 29.6967C87.3072 27.2986 86.2019 26.0996 83.9911 26.0996C82.9851 26.0996 82.1032 26.2899 81.3332 26.6769V33.649H81.3394Z",
    fill: "#231F20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6294 35.603V24.393H92.9335L93.2813 25.8204C94.2438 24.8688 95.3989 24.393 96.7527 24.393V26.0361C95.4424 26.0361 94.3804 26.5119 93.5669 27.4572V35.603H91.6294Z",
    fill: "#231F20"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.634 22.2043H98.7026V20.3328H100.634V22.2043ZM100.634 35.603H98.7026V24.393H100.634V35.603Z",
    fill: "#231F20"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.091 34.9305C111.762 35.381 110.116 35.603 108.166 35.603C104.9 35.603 103.267 33.6617 103.267 29.7728C103.267 26.182 104.999 24.393 108.471 24.393C109.421 24.393 110.315 24.5706 111.16 24.9259V20.3328H113.091V34.9305ZM111.153 26.6769C110.371 26.2899 109.483 26.0996 108.477 26.0996C106.266 26.0996 105.161 27.2986 105.161 29.6967C105.161 32.5388 106.266 33.9599 108.477 33.9599C109.483 33.9599 110.371 33.8203 111.153 33.5412V26.6769Z",
    fill: "#231F20"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4122 53.9184V52.2118C57.7039 52.6369 59.0018 52.8526 60.3245 52.8526C62.0757 52.8526 62.9451 52.3197 62.9451 51.2539C62.9451 50.2579 62.3365 49.7567 61.1194 49.7567H59.5482C57.176 49.7567 55.9961 48.6528 55.9961 46.4451C55.9961 44.3071 57.5176 43.2413 60.5667 43.2413C61.877 43.2413 63.1749 43.4189 64.4666 43.7742V45.4808C63.1749 45.0557 61.877 44.84 60.5667 44.84C58.7409 44.84 57.8281 45.3729 57.8281 46.4387C57.8281 47.4347 58.4056 47.9359 59.5545 47.9359H61.1256C63.6344 47.9359 64.8889 49.0398 64.8889 51.2475C64.8889 53.3855 63.3674 54.4513 60.3307 54.4513C59.008 54.4513 57.7039 54.2737 56.4122 53.9184Z",
    fill: "#231F20"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9941 43.2413H68.0931L71.1982 51.9961L74.4088 43.2413H76.4581L71.8999 54.7875C71.0926 56.824 69.8816 58.0928 68.2608 58.6003L67.5156 57.1983C68.739 56.6527 69.6332 55.7582 70.1921 54.5147L65.9941 43.2413Z",
    fill: "#231F20"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9795 53.9184V52.2118C79.2712 52.6369 80.5691 52.8526 81.8919 52.8526C83.6431 52.8526 84.5187 52.3197 84.5187 51.2539C84.5187 50.2579 83.9101 49.7567 82.6868 49.7567H81.1156C78.7434 49.7567 77.5635 48.6528 77.5635 46.4451C77.5635 44.3071 79.0849 43.2413 82.1341 43.2413C83.4444 43.2413 84.7423 43.4189 86.034 43.7742V45.4808C84.7423 45.0557 83.4444 44.84 82.1341 44.84C80.3083 44.84 79.3954 45.3729 79.3954 46.4387C79.3954 47.4347 79.973 47.9359 81.1218 47.9359H82.693C85.2018 47.9359 86.4563 49.0398 86.4563 51.2475C86.4563 53.3855 84.9348 54.4513 81.8981 54.4513C80.5691 54.4513 79.265 54.2737 77.9795 53.9184Z",
    fill: "#231F20"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8657 41.4205H90.0767L90.4928 43.2349H93.4612V44.8336H90.797V51.2729C90.797 52.3197 91.238 52.8399 92.126 52.8399H93.4612V54.4386H91.623C89.7848 54.4386 88.8657 53.4299 88.8657 51.4188V41.4205Z",
    fill: "#231F20"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M100.255 43.2413C103.379 43.2413 104.938 44.821 104.938 47.974C104.938 48.4244 104.906 48.9002 104.844 49.4141H97.1377C97.1377 51.7043 98.448 52.8526 101.069 52.8526C102.317 52.8526 103.422 52.713 104.391 52.4275V54.0262C103.422 54.3117 102.242 54.4513 100.858 54.4513C97.088 54.4513 95.2002 52.5417 95.2002 48.7162C95.2064 45.0621 96.8893 43.2413 100.255 43.2413ZM97.1377 47.7646H103.075C103.031 45.798 102.093 44.8146 100.249 44.8146C98.3052 44.821 97.2619 45.8043 97.1377 47.7646Z",
    fill: "#231F20"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M107.347 54.4513V43.2413H108.651L108.974 44.6497C110.023 43.7108 111.172 43.2413 112.414 43.2413C114.004 43.2413 115.084 43.7552 115.662 44.7766C116.854 43.7488 118.065 43.2413 119.289 43.2413C121.81 43.2413 123.071 44.6624 123.071 47.5045V54.4576H121.139V47.3903C121.139 45.7155 120.45 44.8781 119.071 44.8781C118.04 44.8781 117.078 45.3602 116.177 46.3309V54.445H114.246V47.4221C114.246 45.7282 113.563 44.8781 112.197 44.8781C111.11 44.8781 110.135 45.3602 109.278 46.3309V54.445H107.347V54.4513Z",
    fill: "#231F20"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M125.536 53.9184V52.2118C126.828 52.6369 128.126 52.8526 129.449 52.8526C131.2 52.8526 132.069 52.3197 132.069 51.2539C132.069 50.2579 131.461 49.7567 130.243 49.7567H128.672C126.3 49.7567 125.12 48.6528 125.12 46.4451C125.12 44.3071 126.642 43.2413 129.691 43.2413C131.001 43.2413 132.299 43.4189 133.591 43.7742V45.4808C132.299 45.0557 131.001 44.84 129.691 44.84C127.865 44.84 126.952 45.3729 126.952 46.4387C126.952 47.4347 127.53 47.9359 128.678 47.9359H130.25C132.758 47.9359 134.013 49.0398 134.013 51.2475C134.013 53.3855 132.491 54.4513 129.455 54.4513C128.126 54.4513 126.828 54.2737 125.536 53.9184Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_99_1611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 24,
    width: 20,
    height: 32
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.8826 28.2058L38.7631 50.3276C39.8561 53.4045 42.7189 55.4473 45.9233 55.4473C48.5067 55.4473 50.3014 52.8272 49.4196 50.3467C49.4196 50.3467 41.3341 27.6602 40.6634 25.7697C39.5394 24.6595 38.1545 24.0885 36.7449 24.0885C34.5838 24.0885 32.3481 25.4208 30.8826 28.2058Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_99_1611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1493 61.8231L21.0149 27.7554L48.0286 17.7127L60.1692 51.7804L33.1493 61.8231Z",
    fill: "url(#paint0_linear_99_1611)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_99_1611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 19,
    width: 38,
    height: 37
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2324 28.2058L10.6068 46.4006C8.17249 51.0001 4.16081 51.4696 3.40939 48.8431C2.90638 51.7741 4.9619 55.4283 9.05432 55.4283C14.2459 55.4283 17.9719 52.6305 21.2633 46.407L30.8826 28.2121C33.317 23.6127 37.8193 22.9656 40.6635 25.7697C39.5084 22.5342 36.5276 19.1845 32.4414 19.1845C27.2435 19.1845 23.5237 21.9759 20.2324 28.2058Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_99_1611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.7848 -0.101517L58.3993 37.3032L21.7848 74.708L-14.8296 37.3032L21.7848 -0.101517Z",
    fill: "url(#paint1_linear_99_1611)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_99_1611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 1,
    width: 19,
    height: 50
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7373 6.40118C10.7373 6.40118 3.80066 46.5529 3.40942 48.8431C4.16084 51.4696 8.17874 51.0001 10.6069 46.4006L16.3574 35.5269L21.3875 6.40752C21.8719 3.60978 19.7605 1.04677 16.9846 1.04677C13.9044 1.04677 11.2713 3.30526 10.7373 6.40118Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_99_1611)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3051 2.56935L21.313 54.686L-5.03003 49.947L3.96212 -2.17603L30.3051 2.56935Z",
    fill: "url(#paint2_linear_99_1611)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_99_1611",
    x1: 38.0422,
    y1: 32.6996,
    x2: 35.0347,
    y2: 24.611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2174,
    stopColor: "#00A3B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5719,
    stopColor: "#008C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006773"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_99_1611",
    x1: 17.8256,
    y1: 33.3026,
    x2: 25.5736,
    y2: 40.8869,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCB813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F16522"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_99_1611",
    x1: 11.448,
    y1: 32.6389,
    x2: 8.15489,
    y2: 50.9204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00ACBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2174,
    stopColor: "#00A3B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5719,
    stopColor: "#008C99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006773"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIc);
export default __webpack_public_path__ + "static/media/Logo_ic.df416b33.svg";
export { ForwardRef as ReactComponent };